const htmlEntityMap: Record<string, string> = {
  amp: '&',
  apos: "'",
  gt: '>',
  lt: '<',
  nbsp: ' ',
  quot: '"',
}

export function stripHtml(input: string) {
  return input
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&([a-z]+);/gi, (_, key: string) => htmlEntityMap[key.toLowerCase()] ?? ' ')
    .replace(/&#(\d+);/g, (_, value: string) => String.fromCharCode(Number(value)))
    .replace(/\s+/g, ' ')
    .trim()
}

export function sentenceSplit(input: string) {
  return input
    .replace(/\s+/g, ' ')
    .split(/(?<=[.!?])\s+/)
    .map((sentence) => sentence.trim())
    .filter(Boolean)
}

export function wordTokens(input: string) {
  return (
    input
      .toLowerCase()
      .match(/[a-z0-9][a-z0-9'-]*/g)
      ?.filter((word) => word.length > 2) ?? []
  )
}

export function truncate(input: string, maxLength: number) {
  if (input.length <= maxLength) return input
  return `${input.slice(0, Math.max(0, maxLength - 1)).trim()}…`
}

export function slugify(input: string) {
  return (
    input
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'newsletter-flow'
  )
}
